/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';

const contentCardWrapperStyled = styled.div`
  .content-card {
    --thumbnail-image: url();
    overflow: hidden;
    position: relative;

    .featured-card-content {
      background-color: var(--white);
    }

    &.content-card-standard {
      .animated-content {
        width: calc(100% - 4.8rem);

        @media ${device.desktop} {
          height: var(--animated-content-height);
          left: 0;
          overflow: hidden;
          position: absolute;
          top: var(--image-offset);
          margin: 2.4rem 3.2rem 3.2rem 3.2rem;
          width: calc(100% - 6.4rem);
        }
      }

      .featured-card {
        &-image {
          padding-bottom: calc(100% * (5 / 6));

          @media ${device.desktop} {
            padding-bottom: calc(100% * 0.762);
          }
        }
      }

      .content-wrapper {
        width: 100%;

        @media ${device.desktop} {
          height: var(--animated-content-height);
        }

        h3 {
          @media ${device.desktop} {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }
        }

        p {
          display: none;

          @media ${device.desktop} {
            display: block;
            margin-top: 4.8rem;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.content-card-slide {
      height: var(--animated-content-height);
      left: 0;
      overflow: hidden;
      position: relative;
      top: var(--image-offset);
      width: 100%;

      @media ${device.desktop} {
        margin: 2.4rem 3.2rem 3.2rem 3.2rem;
        width: calc(100% - 6.4rem);
      }

      .featured-card {
        &-image {
          padding-bottom: calc(100% * (5 / 6));

          @media ${device.desktop} {
            padding-bottom: calc(100% * 0.762);
          }
        }
        &-content {
          display: block;
        }
      }

      .content-wrapper {
        height: var(--animated-content-height);

        h3 {
          @media ${device.desktop} {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }
        }

        p {
          @media ${device.desktop} {
            margin-top: 4.8rem;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }

      .animation-wrapper {
        align-items: flex-start;
        flex-direction: column;
        display: flex;
      }
    }

    &.content-card-horizontal,
    &.content-card-wide-horizontal-short-small {
      .content-wrapper {
        h3 {
          font-weight: 700;
        }
      }
    }

    &.content-card-horizontal,
    &.content-card-wide-horizontal-short-small {
      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.content-card-horizontal,
    &.content-card-large-horizontal,
    &.content-card-wide-horizontal-short,
    &.content-card-wide-horizontal-short-small {
      .featured-card-image {
        padding-bottom: calc(100% * (5 / 6));
      }

      @media ${device.desktop} {
        display: flex;

        .featured-card-image,
        .featured-card-content {
          @media ${device.desktop} {
            flex-basis: 50%;
            position: relative;
          }
        }

        .featured-card-image {
          padding-bottom: 0;
          z-index: 101;
        }

        p {
          display: none;
        }
      }
    }

    &.content-card-media-right {
      @media ${device.desktop} {
        flex-direction: row-reverse;
      }
    }

    &.content-card-horizontal,
    &.content-card-wide-horizontal-short-small {
      .content-wrapper {
        h3 {
          @media ${device.desktop} {
            font-size: 1.6rem;
            line-height: 2.4rem;
            margin: 0 0 3rem 0;
          }
        }
        .publish-date {
          display: none;
        }
      }
    }

    &.content-card-large-horizontal {
      @media ${device.desktop} {
        .featured-card-image {
          flex-basis: 68%;
        }

        .featured-card-content {
          flex-basis: 32%;
          padding: 12rem 4rem;
        }

        .content-wrapper {
          p {
            display: block;
            margin-top: 0;
          }

          .publish-date {
            margin-bottom: 0.8rem;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.content-card-wide-horizontal-short {
      @media ${device.desktop} {
        .featured-card-image {
          flex-basis: 37%;
        }

        .featured-card-content {
          flex-basis: 63%;
          padding: 4.8rem 3rem;
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    .animated-content {
      position: relative;
      z-index: 100;
    }

    .featured-card {
      &-content {
        padding: 2.4rem 2.4rem 3.2rem 2.4rem;
        z-index: 100;

        @media ${device.desktop} {
          padding: 2.4rem 3.2rem 3.2rem 3.2rem;
        }

        .overflow-wrapper {
          overflow: hidden;
          position: relative;
          z-index: 100;
        }
      }
      &-image {
        background-image: url('${(props) => props.thumbnail}');
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        z-index: 1;

        .card-icon-wrapper {
          align-items: center;
          background-color: rgba(var(--grey), 0.85);
          border: 2px solid var(--white);
          border-radius: 50%;
          color: var(--white);
          display: flex;
          height: 80px;
          justify-content: center;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80px;

          span {
            font-size: 3.5rem;
            line-height: 1;
          }
        }
      }
      &-wrapper {
        overflow: hidden;
        position: sticky;

        @media ${device.desktop} {
          justify-content: flex-end;
        }
      }
    }

    .content-wrapper {
      * {
        transition: all 0.3s ease-in-out, color 0.1s ease-in-out;
      }

      .animated-content {
        p {
          font-size: 1.4rem;
        }
      }

      .publish-date {
        display: block;
        color: var(--charcoal-2);
        font-size: 1.2rem;
        letter-spacing: 0.07rem;
        line-height: 1.6rem;
        margin-bottom: 3rem;
        text-transform: uppercase;
      }

      h3 {
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 2.4rem;
        margin: 0 0 1.6rem 0;

        @media ${device.desktop} {
          font-size: 3rem;
          font-weight: 800;
          line-height: 4rem;
          margin: 0 0 0.8rem 0;
        }
      }
    }

    .tag {
      border: 1px solid var(--grey);
      border-radius: 0.4rem;
      color: var(--slate);
      font-size: 1.2rem;
      font-weight: 800;
      letter-spacing: 0.05rem;
      line-height: 1.6rem;
      padding: 0.4rem 0.8rem;
      text-transform: uppercase;
    }

    &.preload * {
      animation: none !important;
      transition: none !important;
    }

    .animation-wrapper {
      @media ${device.desktop} {
        height: 100%;
        padding-top: calc(16rem - 3.2rem);
        overflow: hidden;
        padding-top: 0;

        &:after {
          background-color: var(--grey);
          content: '';
          height: 110%;
          position: absolute;
          right: 200%;
          top: 0;
          transform: skewX(50deg);
          transition: all 0.3s ease-in;
          width: 375%;
          z-index: 1;
        }

        &.hover-in.mounted {
          animation: translate-right 0.3s forwards;

          &::after {
            animation: translate-right 0.5s forwards;
            background-color: var(--slate);
          }
          * {
            color: var(--white);
          }
          .cta-wrapper {
            transform: translateX(0);
            span:first-child {
    background-image: linear-gradient(#fff,#fff);
    background-position: 0 calc(100% - 0px);
    background-repeat: no-repeat;
    background-size: 100% 2px;
    border-bottom: 2px solid transparent;
    transition: background-size .3s;
}
          }

          .animated-content {
            height: 100%;
            top: 0;
          }

          .featured-card-wrapper {
            .content-wrapper {
              bottom: 0;

              p {
                opacity: 1;
              }
            }
          }

          .tag {
            background-color: var(--slate);
            border-color: var(--charcoal);
          }
        }

        &.hover-out.mounted {
          animation: translate-left 0.3s forwards;

          &::after {
            animation: translate-left 0.5s forwards;
          }
          .cta-wrapper {
          }
          .featured-card-wrapper {
            .content-wrapper {
              bottom: var(--bottom-position);

              p {
                transition-delay: 0;
                transition: all 0.2s ease-out;
              }
            }
          }

          .tag {
            background-color: var(--white);
          }
          .cta-wrapper {
            span:first-child{              
    background-size: 0% 2px;
            }
            }
        }
      }
    }

    .cta-wrapper {
      align-items: center;
      color: var(--cta-blue);
      display: flex;
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 2.4rem;
      margin-top: 1rem;
      text-decoration: none;
      width: fit-content;

      span:last-child {
        font-size: 3.2rem;
      }
      @media ${device.tablet} {
        transition: all 0.3s ease-in-out;

        span:first-child {
          transition: all 0.3s ease-in-out;
        }
      }
    }

    @keyframes translate-right {
      from {
        right: 210%;
      }

      to {
        right: -150%;
      }
    }

    @keyframes translate-left {
      from {
        right: -110%;
      }

      to {
        right: 210%;
      }
    }
  }
`;

export default contentCardWrapperStyled;
